export enum CustomClickAndDropHandler {
  ChatButton = 'chatButton',
  LiveChat = 'liveChat',
  WixForm = 'wixForm',
  WixFormApp = 'wixFormApp',
  WixFormToContainer = 'wixFormToContainer',
  AppointmentField = 'appointmentField',
  Blog = 'blog',
  Store = 'store',
  Events = 'events',
  Members = 'members',
  Bookings = 'bookings',
  BookingButton = 'bookingButton',
  SiteSearch = 'siteSearch',
  Blocks = 'blocks',
  PricingPlans = 'pricingPlans',
  Hotels = 'hotels',
}
